import { getSupportedLanguages } from 'utils'
import { getIntentProvidersConstants } from '../constants'
import { sortByKey } from '../../../utils'

const initialState = {}

export default (state = initialState, action = {}) => {
    const { slug } = action
    switch (action.type) {
        case getIntentProvidersConstants.REQUEST:
            return {
                ...state,
                [slug]: {
                    ...(state[slug] || {}),
                    pending: true,
                },
            }
        case getIntentProvidersConstants.SUCCESS: {
            const augmentedProviders = action.response.map(provider => {
                const { lang, symmetric, pairs, ...other } = provider
                const augmentedProvider = {
                    languages: { lang, symmetric, pairs },
                    ...other,
                }
                return {
                    ...augmentedProvider,
                    showBolt:
                        provider.integrated &&
                        provider.billable &&
                        provider.stock_model,
                    supportedLanguages: getSupportedLanguages(
                        augmentedProvider
                    ),
                }
            })
            return {
                ...state,
                [slug]: {
                    response: augmentedProviders.sort(sortByKey('name')),
                    pending: false,
                },
            }
        }
        case getIntentProvidersConstants.FAILURE:
            return {
                ...state,
                [slug]: {
                    error: action.error,
                    pending: false,
                },
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/intentProviders.js